import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';
import { palette } from '../../../Dashboard.styled';

export const Panel = styled.div`
  width: 440px;
  max-width: 92vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: ${palette.ink};
`;

export const Head = styled.div`
  flex: none;
  padding: 22px 26px;
  border-bottom: 1px solid ${palette.borderSoft};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const HeadTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
`;

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${palette.muted};
  display: inline-flex;

  & .MuiSvgIcon-root {
    font-size: 24px;
  }
`;

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 26px;
`;

export const Intro = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: ${palette.muted};
  padding-top: 24px;
`;

export const SectionsTitle = styled.h3`
  margin: 24px 0 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${palette.green};
`;

export const SectionItem = styled.div`
  margin-top: 16px;
  padding-left: 14px;
  border-left: 3px solid ${palette.track};
`;

export const SectionName = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
`;

export const SectionText = styled.p`
  margin: 2px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${palette.muted};
`;

export const Footer = styled.div`
  flex: none;
  border-top: 1px solid ${palette.borderSoft};
  padding: 18px 26px;
  display: flex;
  justify-content: flex-end;
`;

export const CloseAction = styled.button`
  padding: 10px 22px;
  border: none;
  border-radius: 999px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  color: ${colors.WHITE};
  background: ${palette.green};
  cursor: pointer;
`;
